import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------product page api's-------------------------------->
    getamccontracts(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/amc/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getamccontractExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/amc/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getamccontractdetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/amc/details')
    },
    /**
     * to display available amc service for selected product
     * @param {} form 
     * @param {*} token 
     */
    getamcservicelist(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/amcservicelist', id)
    },
    /**
     * create api 
     * @param {*} form 
     */
    postamccontract(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/create', form)
    },
    /**
     * getAmcSerivice from particular id
     */
    getamccontract(id,page,type, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        var url = 'view/' + id+'?type='+type;
        return apiClient.get('/amc/' + url)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postamccontractUpdate(form, id, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/update/' + id, form)
    },
    /**
     * view page
     */
    getAmcContractView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/amc/viewpage/' + id)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postamccontractUpdateService(data, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/updateservice', data)
    },
    /**
     * invoice generate
     */
    getGenerateInvoice(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/amc/invgenerate/' + id)
    },
    /**
     * 
     * @param {*} data 
     */
    postFiltercreateAmcContract(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/filtercreate', data)
    },
    /**
     * 
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateAmcContract(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/filterupdate/' + id, data)
    },
    /**
     * 
     * @param {*} data 
     */
    postFilterdeleteAmcContract(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/filterdelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getAmcContractDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/singledelete', data)
    },
    /**
     * 
     * @param {*} data 
     */
    postservicedeleteAmcContract(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/servicedelete', data)
    },
    /**
     * bulk delete api 
     */
    postAmcContractBulkDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/amc/bulkdelete', data)
    },


}